import { TASK_TYPES } from "components/Dashboard/DoctorDashboard/attachments/constants";
import { usePatientChartsDrive } from "contexts/orchid-drive";
import { useEffect } from "react";
import type { UploadTaskStatusStorageDriveProps } from "../..";
import TaskStatus from "../../../task-status";

const UploadTaskStatusPatientCharts = ({
  tasks,
  setAbortFn,
  onHide,
  onRemoveUpload,
}: UploadTaskStatusStorageDriveProps) => {
  const { uploadTaskAbort } = usePatientChartsDrive({
    patientCharts: [],
  });

  useEffect(() => setAbortFn(uploadTaskAbort), [setAbortFn, uploadTaskAbort]);

  return !tasks.length ? null : (
    <TaskStatus
      variant={TASK_TYPES.upload}
      tasks={tasks}
      // TODO: go with the UX for now, show if has task
      show={true}
      onHide={onHide}
      onCancel={onRemoveUpload}
    />
  );
};

export default UploadTaskStatusPatientCharts;
